export const REQUEST_DOCUMENTS = 'documents/REQUEST_DOCUMENTS';
export const REQUEST_GET_DOCUMENT = 'documents/REQUEST_GET_DOCUMENT';
export const REQUEST_ASSIGN_DOCUMENT_TO_CLIENT = 'documents/REQUEST_ASSIGN_DOCUMENT_TO_CLIENT';
export const REQUEST_UNASSIGN_DOCUMENT_TO_CLIENT = 'documents/REQUEST_UNASSIGN_DOCUMENT_TO_CLIENT';
export const REQUEST_ASSIGN_DOCUMENT_TO_GROUP = 'documents/REQUEST_ASSIGN_DOCUMENT_TO_GROUP';
export const REQUEST_UNASSIGN_DOCUMENT_TO_GROUP = 'documents/REQUEST_UNASSIGN_DOCUMENT_TO_GROUP';
